import { Navigate } from "react-router-dom";
import { usePageVisibility } from "../../hooks/usePageVisibility.js";

/**
 * Route guard — wrap any page whose visibility is admin-controlled. When
 * the matching `pageVisibility[key]` flag is false, the wrapper redirects
 * to /home-designs (the natural fallback for a builder catalogue site).
 *
 * Usage in routes.jsx:
 *
 *   {
 *     path: "house-land",
 *     element: (
 *       <VisibilityGate flag="houseLand">
 *         <HouseLandPage />
 *       </VisibilityGate>
 *     ),
 *   }
 *
 * The visibility hook defaults flags to `true` while the settings query
 * is still loading, so users never see a flash of "page hidden" → real
 * page during a refresh.
 */
export function VisibilityGate({ flag, children, redirectTo = "/home-designs" }) {
  const visibility = usePageVisibility();
  if (visibility[flag] === false) return <Navigate to={redirectTo} replace />;
  return children;
}
